import { Link } from 'react-router-dom';
import { articlePreviews } from '@/mocks/articles';

export default function ArticlePreviewSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 rounded-full bg-foreground-100 text-foreground-600 text-xs font-medium mb-3">
            Neueste Artikel
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            OOPBuy Spreadsheet Wissen
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            Lerne alles über OOPBuy Spreadsheets – von den Grundlagen bis zu Profi-Tipps. Unsere Experten-Guides helfen dir weiter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articlePreviews.map((article) => (
            <Link
              key={article.slug}
              to={`/artikel/${article.slug}`}
              className="group block bg-background-50 border border-background-200/80 rounded-xl overflow-hidden hover:border-primary-200 hover:shadow-lg hover:shadow-primary-500/5 transition-all"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="text-xs text-foreground-500 font-medium bg-foreground-100 px-2 py-0.5 rounded-full">
                  {article.category}
                </span>
                <h3 className="mt-2 font-semibold text-foreground-800 text-sm leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.description}
                </p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="flex items-center gap-1 text-xs text-primary-500 font-medium group-hover:gap-2 transition-all">
                    <span>Weiterlesen</span>
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#kategorien"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-grid-line"></i>
            </span>
            <span>Alle Kategorien entdecken</span>
          </a>
        </div>
      </div>
    </section>
  );
}